module.exports = __webpack_public_path__ + "img/re_upload.00889d36.svg";